export async function generateImageQrCode(uuid) {
  const origin = String(process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');
  const endpoint = `${origin}/museums/generate-image-qr-code/${encodeURIComponent(uuid)}`;
  const uploadPage = `${String(process.env.REACT_APP_FRONTEND_BASE_URL || '').replace(
    /\/$/,
    ''
  )}/upload-image`;
  // Backend appends ?id=<uuid> (see mosida-api generatePaymentQRCode)
  const scanUrl = `${uploadPage}${uploadPage.includes('?') ? '&' : '?'}id=${encodeURIComponent(uuid)}`;
  console.log('[upload QR] scan url (what phone opens):', scanUrl);

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: uploadPage, data: {} }),
    });

    if (!response.ok) {
      const text = await response.text();
      return { success: false, error: `QR API failed: ${response.status} ${text}` };
    }

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const json = await response.json();
      const qrImageUrl =
        json?.data?.qr_image_url ||
        json?.data?.qrImageUrl ||
        json?.qr_image_url ||
        json?.qrImageUrl ||
        json?.data?.url ||
        json?.url;
      return { success: true, data: { qrImageUrl } };
    }

    const text = (await response.text()).trim();
    try {
      return { success: true, data: { qrImageUrl: new URL(text).toString() } };
    } catch {
      return { success: false, error: `Unexpected QR response: ${text.slice(0, 100)}` };
    }
  } catch (err) {
    return { success: false, error: err?.message || 'Network error' };
  }
}
